export const getEmphasizedFontWeight = (variant) => {
    return variant === 'micro' || variant === 'subtitle' ? '600' : '500';
};
